import { Link } from "react-router-dom"

const Missing = () => {
    return (
        <article style={{ padding: "100px" }}>
            <h1>Oops!</h1>
            <p>404 Página Não Existe</p>
            <div className="flexGrow">
                <Link to="/">Voltar</Link>
            </div>
        </article>
    )
}
 
export default Missing
